
import React from 'react';
import { SEO } from '../components/SEO';
import { Award, Users } from 'lucide-react';

const About: React.FC = () => {
  return (
    <>
      <SEO
        title="About Us"
        description="Learn about Palmal Decorators, the leading event decoration company in Midnapore with over 10 years of experience."
        url="/about"
      />

      <div className="bg-maroon-950 pt-24 pb-16 text-center text-white relative">
        <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4 animate-fade-in-up">Our Story</h1>
        <p className="text-gold-400 uppercase tracking-widest text-sm animate-fade-in-up">Passion for Perfection</p>
      </div>

      <div className="bg-white py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center mb-16 md:mb-20">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-gold-100 rounded-full z-0"></div>
              <img
                src="https://lh3.googleusercontent.com/d/1IFFpExxbHZehzzALDaMrrbq789EgA2Eg"
                alt="Our Team Planning"
                className="relative z-10 rounded-lg shadow-2xl w-full h-auto object-contain"
              />
            </div>

            <div className="space-y-6">
              <h2 className="text-3xl font-serif font-bold text-maroon-900">Midnapore's Premier Event Stylists</h2>
              <div className="w-16 h-1 bg-gold-500"></div>
              <p className="text-gray-600 leading-relaxed text-base md:text-lg font-light">
                Located in the heart of Midnapore, <span className="font-semibold text-maroon-900">Palmal Decorators</span> has grown from a humble family business to one of Paschim Medinipur's most sought-after event styling companies since 2012.
              </p>
              <p className="text-gray-600 leading-relaxed text-base md:text-lg font-light">
                We believe that every event tells a story. Whether it's the traditional grandeur of a Bengali wedding or the subtle elegance of a corporate gala, our team of skilled artisans, florists, and designers works tirelessly to bring your unique vision to life.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
                <div className="flex items-start">
                  <Award className="w-8 h-8 text-gold-500 mr-3 flex-shrink-0" />
                  <div>
                    <h4 className="font-bold text-gray-900">Premium Quality</h4>
                    <p className="text-sm text-gray-500">Top-tier materials & flowers</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Users className="w-8 h-8 text-gold-500 mr-3 flex-shrink-0" />
                  <div>
                    <h4 className="font-bold text-gray-900">Expert Team</h4>
                    <p className="text-sm text-gray-500">Skilled artisans & designers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
